import RequireAuth from "@/components/auth/RequireAuth";
import { AuthProvider } from "@/context/AuthContext";
import AuthMarketingLayout from "@/layouts/AuthMarketingLayout";
import RootLayout from "@/layouts/RootLayout";
import WorkspaceLayout from "@/layouts/WorkspaceLayout";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import AuthErrorPageRoute from "@/pages/auth/AuthErrorPage";
import AccountPendingPage from "@/pages/auth/AccountPendingPage";
import ComingSoonPage from "@/pages/auth/ComingSoonPage";
import ForgotPassword2Page from "@/pages/auth/ForgotPassword2Page";
import ForgotPasswordPage from "@/pages/auth/ForgotPasswordPage";
import LoginPage from "@/pages/auth/LoginPage";
import LoginTwoPage from "@/pages/auth/LoginTwoPage";
import ResetPasswordPage from "@/pages/auth/ResetPasswordPage";
import { lazy } from "react";

const RegisterPage = lazy(() => import("@/pages/auth/RegisterPage"));
const RegisterTwoPage = lazy(() => import("@/pages/auth/RegisterTwoPage"));
import NotFoundPage from "@/pages/NotFound";
import WorkspaceAccount from "@/pages/dashboard/Account";
import WorkspaceHome from "@/pages/dashboard/Dashboard";
import BuyCryptoStep1 from "@/pages/dashboard/BuyCryptoStep1";
import BuyCryptoStep2 from "@/pages/dashboard/BuyCryptoStep2";
import BuyCryptoStep3 from "@/pages/dashboard/BuyCryptoStep3";
import BuyCryptoStep4 from "@/pages/dashboard/BuyCryptoStep4";
import WorkspaceCrypto from "@/pages/dashboard/Crypto";
import DepositMoneyStep1 from "@/pages/dashboard/DepositMoneyStep1";
import DepositMoneyStep2 from "@/pages/dashboard/DepositMoneyStep2";
import DepositMoneyStep3 from "@/pages/dashboard/DepositMoneyStep3";
import ExchangeStep1 from "@/pages/dashboard/ExchangeStep1";
import ExchangeStep2 from "@/pages/dashboard/ExchangeStep2";
import ExchangeStep3 from "@/pages/dashboard/ExchangeStep3";
import PayPage from "@/pages/dashboard/Pay";
import PayStep1 from "@/pages/dashboard/PayStep1";
import PayStep2 from "@/pages/dashboard/PayStep2";
import PayStep3 from "@/pages/dashboard/PayStep3";
import PayStepFlow1 from "@/pages/dashboard/PayFlowStep1";
import PayStepFlow2 from "@/pages/dashboard/PayFlowStep2";
import PayStepFlow3 from "@/pages/dashboard/PayFlowStep3";
import PaymentSubmitted from "@/pages/dashboard/PaymentSubmitted";
import ReceiveLanding from "@/pages/dashboard/ReceiveLanding";
import ReceiveStep1 from "@/pages/dashboard/ReceiveStep1";
import ReceiveStep2 from "@/pages/dashboard/ReceiveStep2";
import ReceiveStep3 from "@/pages/dashboard/ReceiveStep3";
import Recipients from "@/pages/dashboard/Recipients";
import Transactions from "@/pages/dashboard/Transactions";
import WithdrawMoneyStep1 from "@/pages/dashboard/WithdrawMoneyStep1";
import WithdrawMoneyStep2 from "@/pages/dashboard/WithdrawMoneyStep2";
import WithdrawMoneyStep3 from "@/pages/dashboard/WithdrawMoneyStep3";
import { BrowserRouter, Route, Routes } from "react-router-dom";

const ROUTER_FUTURE = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

export default function App() {
  return (
    <BrowserRouter future={ROUTER_FUTURE}>
      <AuthProvider>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<AuthMarketingLayout />}>
            <Route path="login" element={<LoginPage />} />
            <Route path="login-2" element={<LoginTwoPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="register-2" element={<RegisterTwoPage />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="forgot-password-2" element={<ForgotPassword2Page />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="account-pending" element={<AccountPendingPage />} />
            <Route path="coming-soon" element={<ComingSoonPage />} />
            <Route path="error" element={<AuthErrorPageRoute />} />
          </Route>
          <Route element={<RootLayout />}>
            <Route element={<RequireAuth />}>
              <Route element={<WorkspaceLayout />}>
                <Route index element={<WorkspaceHome />} />
                <Route path="account" element={<WorkspaceAccount />} />
                <Route path="crypto" element={<WorkspaceCrypto />} />
                <Route path="transactions" element={<Transactions />} />
                <Route path="recipients" element={<Recipients />} />
                <Route path="payment-submitted" element={<PaymentSubmitted />} />
                <Route path="pay" element={<PayPage />} />
                <Route path="pay/step-1" element={<PayStep1 />} />
                <Route path="pay/step-2" element={<PayStep2 />} />
                <Route path="pay/step-3" element={<PayStep3 />} />
                <Route path="pay-step/step-1" element={<PayStepFlow1 />} />
                <Route path="pay-step/step-2" element={<PayStepFlow2 />} />
                <Route path="pay-step/step-3" element={<PayStepFlow3 />} />
                <Route path="receive" element={<ReceiveLanding />} />
                <Route path="receive/step-1" element={<ReceiveStep1 />} />
                <Route path="receive/step-2" element={<ReceiveStep2 />} />
                <Route path="receive/step-3" element={<ReceiveStep3 />} />
                <Route path="exchange/step-1" element={<ExchangeStep1 />} />
                <Route path="exchange/step-2" element={<ExchangeStep2 />} />
                <Route path="exchange/step-3" element={<ExchangeStep3 />} />
                <Route path="deposit-money/step-1" element={<DepositMoneyStep1 />} />
                <Route path="deposit-money/step-2" element={<DepositMoneyStep2 />} />
                <Route path="deposit-money/step-3" element={<DepositMoneyStep3 />} />
                <Route path="withdraw-money/step-1" element={<WithdrawMoneyStep1 />} />
                <Route path="withdraw-money/step-2" element={<WithdrawMoneyStep2 />} />
                <Route path="withdraw-money/step-3" element={<WithdrawMoneyStep3 />} />
                <Route path="buy-crypto/step-1" element={<BuyCryptoStep1 />} />
                <Route path="buy-crypto/step-2" element={<BuyCryptoStep2 />} />
                <Route path="buy-crypto/step-3" element={<BuyCryptoStep3 />} />
                <Route path="buy-crypto/step-4" element={<BuyCryptoStep4 />} />
              </Route>
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
